const colors = {
  primary: '#e8c893',
  secondary: '#252525',
  tertiary: '#1c1c1c',
  orange: '#e08752',
};

const buttons = {
  primary: {
    background: colors.primary,
    borderColor: '#fff',
    colorIcon: colors.primary,
    hover: colors.tertiary,
    color: '#000',
    themes: {
      gold: {
        background: colors.primary,
        color: '#000',
      },
      gray: {
        background: '#242525',
        color: colors.primary,
      },
    },
  },
  secondary: {
    borderColor: colors.primary,
    hover: colors.tertiary,
    color: '#fff',
  },
  tertiary: {
    borderColor: colors.primary,
    hover: colors.tertiary,
    color: '#fff',
  },
};

const input = {
  font: {
    size: '1rem',
  },
  background: '#4b4b4b',
  color: 'rgb(255, 255, 255)',
  placeholder: '#b0b0b0',
  label: 'rgb(255, 255, 255)',
  labelAfter: 'rgb(100, 100, 100)',
  error: 'rgb(220, 40, 30)',
  padding: '15px',
};

export const theme = Object.assign({}, { colors, buttons, input });

type Theme = typeof theme;
declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
}
